module.exports=function(scope){ return `// This sample code demonstrates using onBeforeZoomDismiss to tweak ZFaceTecoOm exit animations and timing.
// This function must return true to signal to FaceTec that the developer is making an explicit decision to override the default dismiss behavior.
func onBeforeZoomDismiss(result: ZoomSessionResult) -> Bool {
  DispatchQueue.main.async {
      // In this example, we do an alpha+scale animation to make the FaceTec Interface disappear.  Developers can change this to suit their application.
      UIView.animate(withDuration: 0.5, delay: 0, options: .curveEaseOut, animations: {
          self.sessionVC.view.alpha = 0
          self.sessionVC.view.transform = CGAffineTransform.identity.scaledBy(x: 0.8, y: 0.8)
      }, completion: { finished in
          // Make sure to dismiss the User Session VC when done.
          self.sessionVC.dismiss(animated: false, completion: nil)
      })
  }

  return true
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/37-exit-animations.swift.tpl